import { Link } from "react-router-dom";
import { Youtube, Instagram, ExternalLink, ArrowRight } from "lucide-react";
import { MediaView } from "./MediaView";
import { SmartGallery } from "./SmartGallery";
import { MapsWaze } from "./MapsWaze";
import { ActionButtons } from "./ActionButtons";
import { Modal, ModalScroll, ModalMedia } from "./Modal";

// Elegant popup that shows a full news item without leaving the homepage.
export const NewsModal = ({ item, onClose }) => {
  const showExcerpt = item?.excerpt && (!item.content || !item.content.includes(item.excerpt.trim()));
  const socials = item ? [
    item.youtube && { href: item.youtube, icon: Youtube, label: "Voir sur YouTube" },
    item.instagram && { href: item.instagram, icon: Instagram, label: "Voir sur Instagram" },
    item.externalUrl && { href: item.externalUrl, icon: ExternalLink, label: "Découvrir la vidéo" },
  ].filter(Boolean) : [];

  return (
    <Modal open={!!item} onClose={onClose} size="lg" testid="news-modal">
      {item && (
        <ModalScroll testid="news-modal-scroll">
          {(item.image || item.videoUrl || item.mediaType === "slideshow") && (
            <ModalMedia><MediaView item={item} alt={item.title} fit="contain" frame={item.detailFrame} /></ModalMedia>
          )}

          <div className="p-6 md:p-8">
            <div className="flex items-center gap-4 mb-3">
              <span className="text-[10px] tracking-[0.3em] uppercase text-electric">{item.category || "Actualité"}</span>
              {item.date && <span className="text-[10px] tracking-[0.2em] uppercase text-secondary2">{item.date}</span>}
            </div>
            <h2 data-testid="news-modal-title" className="font-serif text-3xl md:text-4xl text-white leading-tight mb-4">{item.title}</h2>

            {(item.locationName || item.address) && (
              <div className="mb-5"><MapsWaze name={item.locationName} address={item.address} testid="news-modal-location" /></div>
            )}

            {showExcerpt && <p className="text-lg text-white/90 font-light leading-relaxed mb-4">{item.excerpt}</p>}
            {item.content && <div className="text-base text-secondary2 font-light leading-relaxed whitespace-pre-line mb-6">{item.content}</div>}

            {(item.gallery || []).length > 0 && (
              <div className="mb-6"><SmartGallery images={item.gallery} options={item.gallerySettings || { mode: item.galleryMode || "fade", autoplay: item.galleryAutoplay !== false }} label="" /></div>
            )}

            {socials.length > 0 && (
              <div className="flex flex-wrap gap-3 mb-6">
                {socials.map((s, x) => (
                  <a key={x} href={s.href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/15 text-white text-[11px] tracking-[0.1em] uppercase hover:border-electric hover:text-electric transition-colors"><s.icon size={15} /> {s.label}</a>
                ))}
              </div>
            )}

            {(item.actions || []).length > 0 && (
              <div className="mb-6"><ActionButtons actions={item.actions} context={{ refId: item.id, refTitle: item.title }} /></div>
            )}

            {(item.learnMore || item.registrationEnabled || item.joinEnabled) && (
              <Link to={`/actualites/${item.id}`} data-testid="news-modal-full" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-electric text-black text-[12px] tracking-[0.12em] uppercase font-semibold hover:bg-white transition-colors">
                En savoir plus <ArrowRight size={15} />
              </Link>
            )}
          </div>
        </ModalScroll>
      )}
    </Modal>
  );
};
